import { createAction, props } from '@ngrx/store';
import { ViewContext } from '../enums';
import { HoverDataAllFields } from '../interfaces';

export const ActionTypes = {
	load: '[HoverChart] Load',
	load_success: '[HoverChart] Load Success',
	reset: '[HoverChart] Reset',
};

export const loadHoverData = createAction(
	ActionTypes.load,
	props<{ layerType: Lowercase<ViewContext>; id: string; cityId: string }>(),
);

export const loadHoverDataSuccess = createAction(
	ActionTypes.load_success,
	props<{ payload: HoverDataAllFields }>(),
);

export const resetHoverData = createAction(ActionTypes.reset);
